// Affiliate referral tracking utility
import { API_URL } from '../config';

const REF_KEY = 'affiliate_ref';

/** Capture ?ref= param from URL into localStorage */
export function captureReferral() {
  const params = new URLSearchParams(window.location.search);
  const ref = params.get('ref');
  if (ref) {
    localStorage.setItem(REF_KEY, ref);
    trackClick(ref);
  }
}

/** Get stored affiliate code (or null) */
export function getStoredReferral() {
  return localStorage.getItem(REF_KEY);
}

/** Clear stored referral after conversion */
export function clearReferral() {
  localStorage.removeItem(REF_KEY);
}

/** Track a referral click */
async function trackClick(affiliateCode) {
  try {
    await fetch(`${API_URL}/api/affiliate/track-click`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        affiliate_code: affiliateCode,
        page_url: window.location.pathname,
        referrer: document.referrer || null
      })
    });
  } catch (e) { /* silent */ }
}

/** Track a conversion (call after successful payment) */
export async function trackConversion(amount, product) {
  const affiliateCode = getStoredReferral();
  if (!affiliateCode) return null;

  try {
    const res = await fetch(`${API_URL}/api/affiliate/track-conversion`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        affiliate_code: affiliateCode,
        amount,
        product
      })
    });
    const data = await res.json();
    if (data.success) clearReferral();
    return data;
  } catch (e) {
    return null;
  }
}
